import { TextField, TextFieldProps } from '@mui/material';
import { Control, FieldValues } from 'react-hook-form';

type DialogTextFieldProps = TextFieldProps & {
    name: string;
    control: Control<FieldValues>;
    defaultValue?: string;
};

const DialogTextField = (props: DialogTextFieldProps) => {
    const { name, control, defaultValue = '', ...rest } = props;

    return (
        <TextField
            autoFocus
            margin="dense"
            defaultValue={defaultValue}
            {...rest}
            {...control.register(name, {
                shouldUnregister: true,
                required: true,
            })}
        />
    );
};

export default DialogTextField;
